import { ActionReducerMap, createFeatureSelector } from "@ngrx/store"
import * as placeOrder from "./home/containers/store/place-order/place-order-reducer"
import * as menu from "./home/containers/store/menu/menu.reducer"
import * as menuOrder from "./home/containers/store/menu-order/menu-order.reducer"

export interface AppState {
  placeOrder : placeOrder.State,
  menu: menu.State,
  menuOrder: menuOrder.State
}

export const appReducer: ActionReducerMap<AppState>={
  placeOrder: placeOrder.placeOrderReducer,
  menu: menu.menuReducer,
  menuOrder: menuOrder.menuOrderReducer
}

export const getPlaceOrderState = createFeatureSelector<placeOrder.State>('placeOrder')
export const getMenuState = createFeatureSelector<menu.State>('menu')
export const getMenuOrderState = createFeatureSelector<menuOrder.State>('menuOrder')
